const initialState = {
	imageModalOpen: false,
	imageCropAspectRatio: 16 / 9,
};

export default initialState;

